import { ConfidentialResourceType } from '@dreryk/egabinet-medical-data-confidentiality-frontend-api';

import { assertUnreachable } from '@dreryk/react-common';

// eslint-disable-next-line complexity
export const mapMedicalDocumentTypeToConfidentialResourceType = (
   medicalDocumentTypeCode: string
): ConfidentialResourceType => {
   switch (medicalDocumentTypeCode) {
      case 'VISIT_SUMMARY':
      case 'MEDICAL_CERTIFICATE':
      case 'ZLA_DOCUMENT_XML':
      case 'ZLA_DOCUMENT_PDF':
      case 'PRESCRIPTION':
      case 'REFERRAL':
      case 'REFERRAL_TO_HOSPITAL':
      case 'REFERRAL_TO_DIAGNOSTIC_EXAMINATION':
      case 'REFERRAL_TO_ANALYTICAL_EXAMINATION':
      case 'MEDICAL_DEVICE_ORDER':
      case 'REFERRAL_TO_SPECIALIST':
      case 'REFERRAL_TO_REHABILITATION':
      case 'REFERRAL_TO_PSYCHIATRIC_HOSPITAL':
      case 'E_REFERRAL_TO_HOSPITAL':
      case 'E_REFERRAL_TO_DIAGNOSTIC_EXAMINATION':
      case 'E_REFERRAL_TO_SPECIALIST':
      case 'DOCUMENT_FROM_TEMPLATE':
      case 'DISCHARGE_SUMMARY':
      case 'DISCHARGE_SUMMARY_TRANSFORMED':
         return 'MEDICAL_DOCUMENT';

      case 'MEDICAL_DOCUMENTATION':
         return 'PATIENT_MEDICAL_DOCUMENTATION';

      default:
         return assertUnreachable(medicalDocumentTypeCode as never);
   }
};
